import React from 'react'
import PropTypes from 'prop-types'

import { ContentModal, Flex, Title, P, Button } from 'ui/acro'
import styled from 'styled-components'
import { css } from '@styled-system/css'
import ModalImage from './ModalImage'

const StyledTitle = styled(Title)(
  {
    fontFamily: 'Proxima-Nova',
    fontStyle: 'normal',
    fontWeight: 600
  },
  css({
    fontSize: ['24px', '24px', '32px'],
    letterSpacing: ['-0.72px', '-0.72px', '-0.96px'],
    lineHeight: ['135%', '135%', '40px']
  })
)

const StyledButton = styled(Button)({
  fontFamily: 'Proxima-Nova',
  fontSize: '18px',
  fontStyle: 'normal',
  fontWeight: '700',
  lineHeight: '24px',
  letterSpacing: '0.9px',
  textTransform: 'uppercase',
  width: '100%',
  marginBottom: '16px',
  borderRadius: '0px'
})

const HomeRebrand = ({ useModal }) => {
  return (
    <ContentModal
      useModal={useModal}
      overflow='hidden'
      style={{ maxWidth: '862px', borderRadius: 0, border: 'none' }}
    >
      <Flex flexDirection={['column', null, 'row']}>
        <ModalImage />
        <Flex
          width={['100%', null, '50%']}
          flexDirection='column'
          justifyContent='center'
          px={['16px', null, '48px']}
          py={['16px', null, null]}
        >
          <StyledTitle mb={['4px', null, '8px']} wordBreak='break-word'>
            ALLOW US TO REINTRODUCE OURSELVES
          </StyledTitle>

          <P mb={['16px', null, '28px']}>Welcome to ALO Wellness Club.</P>
          <P mb={['16px', null, '28px']}>
            Keep your same access and virtually train like a VIP with exciting
            new launches from top ALO Wellness Club instructors around the
            world.
          </P>

          <Flex flexDirection='column'>
            <StyledButton
              onClick={() => useModal.close()}
              variant='primary'
              id='survey_retake'
              aria-label='Retake Survey'
              style={{ borderRadius: 0 }}
            >
              LET’S GO
            </StyledButton>
          </Flex>
        </Flex>
      </Flex>
    </ContentModal>
  )
}

HomeRebrand.propTypes = {
  useModal: PropTypes.object.isRequired
}

export default HomeRebrand
